import { buildWorkflowFromCodePrompt } from '@/ai/prompts'
import { fetchJsonResponse, streamJsonResponses } from '@/ai/api'

export const generateWorkflowFromCode = async ({
  workflow,
  codeSnippets,
  workflowSteps,
  description,
  stream = true,
  onChunkReceived,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }
  if (stream && typeof onChunkReceived !== 'function') {
    return null
  }

  const messages = buildWorkflowFromCodePrompt({ codeSnippets, workflowSteps, description, stream })

  if (stream) {
    const response = await streamJsonResponses({
      messages,
      useCase: 'workflow-from-code',
      aiVersion: workflow.aiVersion,
      onChunkReceived,
      signal: abortController?.signal
    })

    return response || null
  } else {
    const response = await fetchJsonResponse({
      messages,
      useCase: 'workflow-from-code',
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    return response || null
  }
}
